<template>
  <div>
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
      <Tooltip :label="setting.label || name" :content="setting.detail" />
    </span>
    <el-date-picker
      v-model="value[name]"
      type="date"
      format="dd-MM-yyyy"
      placeholder="Pick a day"
      style="margin-bottom: 20px"
    >
    </el-date-picker>
  </div>
</template>

<script>
/**
 * Date SmartField - Renders a date picker for date configuration values.
 *
 * @component
 * @description Displays a date picker with DD-MM-YYYY format for selecting dates.
 * Stores the selected date value in the configuration object.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the date picker (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Date|string} [setting.default] - Default date value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Date
 *   :value="config"
 *   :setting="{ label: 'Start Date', detail: 'Select the start date' }"
 *   name="startDate"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
